module.exports = "<app-page-header title=\"REPORT\" icon=\"bar_chart\"></app-page-header>"